import { render, staticRenderFns } from "./newBasic.vue?vue&type=template&id=45ddf73e&"
import script from "./newBasic.vue?vue&type=script&lang=js&"
export * from "./newBasic.vue?vue&type=script&lang=js&"
import style0 from "./newBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports